export const SUB_CATEGORY_LISTING= 'SUB_CATEGORY_LISTING'
export const SUB_CATEGORY_LISTING_SUCCESS= 'SUB_CATEGORY_LISTING_SUCCESS'

export const SUB_CATEGORY_LISTING_PAGINATION_DATA= 'SUB_CATEGORY_LISTING_PAGINATION_DATA'

export const SUB_CATEGORY_DETAIL = 'SUB_CATEGORY_DETAIL'
export const SUB_CATEGORY_DETAIL_SUCCESS = 'SUB_CATEGORY_DETAIL_SUCCESS'